import {CarouselProvider, Dot, Slide, Slider,} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import {CarouselSlides} from "../../data/CarouselSlides/CarouselSlides.config";
import {useEffect, useState} from "react";
import classes from "../../data/sass/CarouselHeader.module.css";
import Image from "next/image";
import {useTranslation} from "next-i18next";

export default function CarouselHeader() {
	const [isHoveringNext, setIsHoveringNext] = useState(false);
	const transitionTime = 5000;
	const {t} = useTranslation();
	const [currSlide, setCurrSlide] = useState(0);
	useEffect(() => {
		const interval = setTimeout(() => {
			if (currSlide < CarouselSlides.length - 1) {
				setCurrSlide((currSlide) => currSlide + 1);
			} else {
				setCurrSlide(0);
			}
		}, transitionTime);
		return () => clearInterval(interval);
	}, [currSlide]);

	return (
		<CarouselProvider
			currentSlide={currSlide}
			infinite={true}
			naturalSlideHeight={7}
			naturalSlideWidth={16}
			interval={transitionTime}
			totalSlides={CarouselSlides.length}
			className="h-[50vh] lg:h-[80vh]"
		>
			<div className="absolute bottom-[63vh] lg:bottom-[40vh] w-full z-10 px-5 md:px-20 text-white flex flex-col lg:flex-row items-end justify-center gap-10">
				<div className="flex flex-col gap-6 w-full text-center">
					<h1 className="font-light text-[32px] lg:text-[64px] xl:text-[80px]">
						{t("components.carouselHeader.titleLine1")}
					</h1>
				</div>

				<div
					className="flex flex-col self-start lg:self-end items-end hidden"
					id="dots"
				>
					<div className="flex justify-between w-64 ">
						{CarouselSlides.map((dot, dotIdx) => {
							return (
								<Dot slide={dotIdx} key={dotIdx} className="w-9 h-1">
									<div
										className={`w-full h-full`}
										style={{
											background:
												"linear-gradient(to left, rgba(255, 255, 255, 0.5) 50%, white 50%) right",
											backgroundSize: "200% 100%",
											animationDuration: `${transitionTime + 100}ms`,
											backgroundPosition: "right",
											transitionTimingFunction: "linear",
											animationName:
												dotIdx === currSlide
													? classes["bg-right-to-left"]
													: undefined,
										}}
									/>
								</Dot>
							);
						})}
					</div>
					{/* <button
          className="h-full w-10 text-white mt-8"
          onMouseEnter={() => setIsHoveringNext(true)}
          onMouseLeave={() => setIsHoveringNext(false)}
        >
          <IconNext
            className={`${
              isHoveringNext && "translate-x-5"
            } transition duration-300`}
          />
        </button> */}
				</div>
			</div>
			<Slider className="h-[50vh] lg:h-[80vh]">
				{CarouselSlides.map((slide, idx) => {
					return (
						<Slide
							key={idx}
							index={idx}
							style={{
								height: "80vh",
							}}
						>
							<Image
								quality={90}
								src={slide.img}
								fill
								style={{objectFit: "cover"}}
								alt="Leon Inmobiliara"
								className=""
								loading="eager"
							/>
							{/* <div className="absolute w-full h-full bg-gradient-to-t from-[rgba(0,0,0,0.6)] via-40% via-[rgba(0,0,0,0.4)] to-transparent"></div> */}
							{/* <div className="flex flex-col items-center absolute gap-2 top-[63vh] lg:left-[75%] left-4">
                <div className="flex gap-2">
                  <div className="max-w-[220px] w-fit text-white">
                    {slide.desc.substring(0, 50)}...
                  </div>
                </div>
              </div> */}
						</Slide>
					);
				})}
			</Slider>
		</CarouselProvider>
	);
}
